var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGuide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    width: "800px",
    height: "800px",
    viewBox: "0 0 32 32",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27,3c0,-0.552 -0.448,-1 -1,-1l-20,0c-0.552,0 -1,0.448 -1,1l-0,26c0,0.552 0.448,1 1,1l20,-0c0.552,-0 1,-0.448 1,-1l0,-26Zm-2,1l0,24c-0,-0 -18,-0 -18,-0c-0,-0 -0,-24 -0,-24l18,0Zm-14,22l10,-0c0.552,-0 1,-0.448 1,-1c-0,-0.552 -0.448,-1 -1,-1l-10,-0c-0.552,-0 -1,0.448 -1,1c-0,0.552 0.448,1 1,1Zm2,-3l6,0c0.552,0 1,-0.448 1,-1c0,-0.552 -0.448,-1 -1,-1l-6,0c-0.552,0 -1,0.448 -1,1c0,0.552 0.448,1 1,1Zm2.955,-3.5l0.09,-0c3.843,-0.024 6.955,-3.152 6.955,-7c0,-3.848 -3.112,-6.976 -6.955,-7l-0.09,0c-3.843,0.024 -6.955,3.152 -6.955,7c0,3.848 3.112,6.976 6.955,7Zm0.045,-5.5c0.552,0 1,0.448 1,1c0,0.552 -0.448,1 -1,1c-0.552,-0 -1,-0.448 -1,-1c0,-0.552 0.448,-1 1,-1Zm-1,-4l0,2c-0,0.552 0.448,1 1,1c0.552,0 1,-0.448 1,-1l0,-2c-0,-0.552 -0.448,-1 -1,-1c-0.552,0 -1,0.448 -1,1Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuide);
export default __webpack_public_path__ + "static/media/guide.77059748d95d44d5d3eb88538769e2fe.svg";
export { ForwardRef as ReactComponent };